'use strict';

var ROMSummaryPOSFilterFactory = function ROMSummaryPOSFilterFactory(DataFilter) {
  function ROMSummaryPOSFilter() {
    DataFilter.call(this, 'rom-summary-mode', 'pos', 0);
  }
  ROMSummaryPOSFilter.prototype = Object.create(DataFilter.prototype);
  ROMSummaryPOSFilter.prototype.groupBy = 'spos';
  return ROMSummaryPOSFilter;
};
ROMSummaryPOSFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ROMSummaryPOSFilterFactory;